module.exports = __webpack_public_path__ + "static/media/logo-white.20201f0d.svg";